module.exports = __webpack_public_path__ + "static/media/bg-pageb73cb1af6a195291506d70f8d1cc7093.webp";